<template>
  <v-container fluid class="mx-0 px-0">
    <!-- Temperature Chart -->
    <template v-if="!loading">
      <highcharts
        ref="highchart"
        :constructor-type="'stockChart'"
        :options="temperatureChartOptions"
      ></highcharts>

      <highcharts
        ref="highchart"
        :constructor-type="'stockChart'"
        :options="rainChartOptions"
      ></highcharts>

      <highcharts
        ref="highchart"
        :constructor-type="'stockChart'"
        :options="windChartOptions"
      ></highcharts>

      <highcharts
        ref="highchart4"
        :constructor-type="'stockChart'"
        :options="pressureChartOptions"
      ></highcharts>
    </template>
    <template v-else>
      <v-skeleton-loader type="card"></v-skeleton-loader>
    </template>
  </v-container>
</template>

<script>
import { ref } from "vue";

import moment from "moment";

// Components

// Highcharts
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import stockInit from "highcharts/modules/stock";

// API helper
import api from "../../api";

import cardinals from "../../cardinals";
import { iconUrl } from "../../iconUrl";

// Load the full build.
var _ = require("lodash");

stockInit(Highcharts);

export default {
  name: "Cities",

  components: {
    highcharts: Chart,
  },

  data: () => ({
    forecasts: [],
    forecasts3: [],
    loading: true,
  }),

  computed: {
    // Temperature Chart Options
    temperatureChartOptions() {
      let series = [];
      let tmaxData = [];
      let tsData = [];
      let dewPiont = [];
      let forecasts = this.forecasts;

      let formatIcon = this.formatIcon;

      let night = [];
      let actualNight = {};

      let minA = [];
      let maxA = [];
      let min = 0;
      let max = 0;

      forecasts.forEach((previ, index) => {
        tmaxData.push([
          moment(previ.timestamp * 1000).unix() * 1000,
          +Math.round(previ.tmax),
        ]);

        tsData.push({
          x: moment(previ.timestamp * 1000).unix() * 1000,
          y: +previ.tmax + 5,
          marker: {
            symbol: `url(${formatIcon(index)})`,
            height: 20,
            width: 20,
          },
        });

        dewPiont.push([
          moment(previ.timestamp * 1000).unix() * 1000,
          +Math.round(previ.dptmin),
        ]);

        minA.push(+Math.round(previ.tmax));
        minA.push(+Math.round(previ.dptmin));

        maxA.push(+Math.round(previ.tmax));
        maxA.push(+Math.round(previ.dptmin));

        min = Math.min(...minA);
        min = Math.floor(min / 10) * 10;

        max = Math.max(...maxA);
        max = Math.ceil(max / 10) * 10 + 10;

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment(previ.timestamp * 1000).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index + 1 === forecasts.length)
        ) {
          actualNight.to = moment(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });
      series.push({
        showInLegend: false,
        color: "#ff0000",
        data: tmaxData,
        yAxis: 0,
        name: this.$t("forecasts.temperatureChart.title1"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: tsData,
        type: "scatter",
        yAxis: 0,
        name: this.$t("forecasts.temperatureChart.title1"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      series.push({
        color: "#1dff00",
        data: dewPiont,
        yAxis: 1,
        name: this.$t("forecasts.temperatureChart.title2"),
        states: {
          hover: {
            enabled: false,
          },
        },
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 5,
            tickInterval: 10,
            min: min,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend1"),
            },
            opposite: false,
          },
          {
            tickAmount: 5,
            tickInterval: 10,
            min: min,
            max: max,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend1"),
            },
          },
          {
            tickAmount: 5,
            tickInterval: 10,
            min: min,
            max: max,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.temperatureChart.legend2"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          series: {
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
          line: {
            dataLabels: {
              // useHTML: true,
              enabled: false,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
              formatter: function () {
                if (this.point.index % 3 === 0)
                  return String(Math.round(this.y * 100) / 100).replaceAll(
                    ".",
                    ","
                  );
              },
            },
            enableMouseTracking: true,
          },
        },
        chart: {
          animation: false,
        },
        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: [
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                ],
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    rainChartOptions() {
      let series = [];
      let rain = [];
      let snow = [];
      let rainMin = [];
      let rainvalues = [];
      let rmax = null;
      let forecasts = this.forecasts;

      let night = [];
      let actualNight = {};

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        if (previ.csnowsfc > 0) {
          snow.push([
            moment(previ.timestamp * 1000).unix() * 1000,
            Math.round(((previ.apcpsfc * previ.csnowsfc * 8) / 10) * 10) / 10,
          ]);
        } else {
          rain.push([
            moment(previ.timestamp * 1000).unix() * 1000,
            Math.round(previ.apcpsfc * 10) / 10,
          ]);
          rainvalues.push(Math.round(previ.apcpsfc * 10) / 10);
        }

        rainMin.push([
          moment(previ.timestamp * 1000).unix() * 1000,
          Math.floor(Math.round(previ.rhmin * 10) / 10),
        ]);
        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment(previ.timestamp * 1000).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      rmax = _.max(rainvalues) + 10;

      series.push({
        type: "column",
        name: "Neige (cm)",
        data: snow,
        color: "grey",
        yAxis: 0,
      });
      series.push({
        type: "column",
        name: "Pluie (mm)",
        data: rain,
        yAxis: 0,
      });
      series.push({
        data: rainMin,
        color: "#030D6B",
        name: "Humidité (%)",
        yAxis: 1,
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];
            if (!this.points) return "";
            this.points.forEach((point, index) => {
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 7,
            min: 0,
            max: rmax,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: "Pluie",
            },
            opposite: false,
          },
          {
            tickAmount: 3,
            min: 0,
            max: 100,
            labels: {
              format: "{value:.0f}",
            },
            title: {
              text: this.$t("forecasts.rainChart.legend2"),
            },
          },
        ],
        plotOptions: {
          series: {
            showInNavigator: true,
          },
          column: {
            dataLabels: {
              verticalAlign: "top",
              x: 0,
              y: -22,
              padding: 0,
              align: "center",
              enabled: true,
              style: {
                fontSize: "12px",
              },
              formatter: function () {
                let value = Math.round(this.y * 100) / 100;
                if (value > 0) {
                  return String(value).replaceAll(".", ",");
                } else {
                  return "";
                }
              },
            },
            enableMouseTracking: true,
          },
        },
        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: [
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                  {
                    labels: {
                      align: "left",
                      x: 0,
                      y: -5,
                    },
                    title: {
                      text: null,
                    },
                  },
                ],
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    windChartOptions() {
      let series = [];
      let windSpeed = [];
      let gust = [];
      let forecasts = this.forecasts;
      let getArrow = this.getArrow;

      let night = [];
      let actualNight = {};

      let max = 0;

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        windSpeed.push([
          moment(previ.timestamp * 1000).unix() * 1000,
          Math.floor(previ.wind_speed * 3.6),
        ]);

        gust.push([
          moment(previ.timestamp * 1000).unix() * 1000,
          Math.ceil(previ.gustsfc * 3.6),
        ]);

        if (Math.ceil(previ.gustsfc) > max) max = Math.ceil(previ.gustsfc);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment(previ.timestamp * 1000).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      max += 10;

      // Push data into series array
      series.push({
        color: "#0037ff",
        data: windSpeed,
        yAxis: 0,
        name: this.$t("forecasts.windChart.title1"),
        dataLabels: {
          align: "top",
          formatter() {
            if (this.point.index % 3 === 0)
              return `<p><i class="fas fa-long-arrow-alt-up"
                    style="margin-left:5px;transform: rotate(${getArrow(
                      cardinals(Math.round(forecasts[this.point.index].dir))
                    )+180}deg)"
                  ></i></p>`;
          },
        },
      });

      series.push({
        color: "#ff0000",
        data: gust,
        yAxis: 1,
        name: this.$t("forecasts.windChart.title2"),
        dataLabels: {
          enabled: false,
        },
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];
            if (!this.points) return "";
            this.points.forEach((point, index) => {
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.windChart.legend1"),
            },
          },
          {
            tickAmount: 3,
            tickInterval: 10,
            min: 0,
            labels: {
              enabled: false,
            },
            title: {
              text: this.$t("forecasts.windChart.legend2"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          line: {
            dataLabels: {
              useHTML: true,
              enabled: true,
              verticalAlign: "top",
              align: "center",
              x: 0, // Offset des points
              y: -22,
              padding: 0,
              style: {
                fontSize: "12px",
              },
            },
            enableMouseTracking: true,
          },
        },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: {
                  labels: {
                    align: "left",
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    pressureChartOptions() {
      let series = [];
      let pressure = [];
      let forecasts = this.forecasts;

      let night = [];
      let actualNight = {};

      let max = 0;
      let min = 100000

      // Loop trough forecasts array and push [time, value]
      forecasts.forEach((previ, index) => {
        pressure.push([
          moment(previ.timestamp * 1000).unix() * 1000,
          Math.floor(previ.prmslmsl),
        ]);
        if(parseInt(previ.prmslmsl) > max)
        {
          max = previ.prmslmsl
        }
        if(parseInt(previ.prmslmsl) < min)
        {
          min = previ.prmslmsl
        }

        if (previ.prmslmsl > max) max = Math.ceil(previ.prmslmsl);

        if (previ.is_night && !actualNight.from) {
          actualNight.color = "#E2E2E2";
          actualNight.from = moment(previ.timestamp * 1000).unix() * 1000;
        } else if (
          (!previ.is_night && actualNight.from) ||
          (actualNight.from && index === forecasts.length - 1)
        ) {
          actualNight.to = moment(forecasts[index - 1].date).unix() * 1000;

          night.push(actualNight);
          actualNight = {};
        }
      });

      max += 10;

      // Push data into series array
      series.push({
        color: "#0037ff",
        data: pressure,
        yAxis: 0,
        name: this.$t("forecasts.pressureChart.title1"),
      });

      // Return the chart options for axis
      return {
        tooltip: {
          formatter() {
            let tooltipArray = [
              moment(this.x).format("Do MMMM YYYY[,] H[h]mm"),
            ];

            this.points.forEach((point, index) => {
              tooltipArray.push(
                point.series.name + ": " + point.y.toFixed(1) + "</b>"
              );
            });

            return tooltipArray;
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: (e) => {
              if (new Date(e.value).getHours() === 0) {
                return moment(e.value).format("D MMM");
              }
              return moment(e.value).format("HH[h]");
            },
            style: {
              fontSize: "10px",
            },
          },
          events: {
            setExtremes: this.syncExtremes,
          },
          plotBands: night,
          tickPositions: this.tickArray,
        },
        yAxis: [
          {
            max: max,
            min: min,
            labels: {
              format: "{value}",
            },
            opposite: false,
            title: {
              text: this.$t("forecasts.pressureChart.legend1"),
            },
          },
          {
            max: max,
            min: min,
            labels: {
              format: "{value}",
            },
            title: {
              text: this.$t("forecasts.pressureChart.legend1"),
            },
          },
        ],
        // Labels Options
        plotOptions: {
          line: {
            enableMouseTracking: true,
          },
        },

        time: {
          useUTC: false,
        },
        series,
        rangeSelector: {
          enabled: false,
        },
        navigator: {
          enabled: true,
        },
        scrollbar: {
          enabled: false,
        },
        legend: {
          align: "center",
          enabled: true,
          layout: "horizontal",
          verticalAlign: "top",
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  align: "center",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                },
                yAxis: {
                  labels: {
                    align: "left",
                    x: 0,
                    y: -5,
                  },
                  title: {
                    text: null,
                  },
                },
                subtitle: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
              },
            },
          ],
        },
      };
    },

    tickArray() {
      let forecasts = this.forecasts3;

      let res = [];

      forecasts.forEach((chunk, index) => {
        if (
          new Date(chunk.date).getHours() === 0 ||
          new Date(chunk.date).getHours() === 12
        )
          res.push(moment(chunk.date).unix() * 1000);
      });

      return res;
    },
  },

  methods: {
    /**
     * Fetch API, get forecasts & select only wanted time
     */
    async getForecasts() {
      this.loading = true;
      try {
        let result = await api.forecast.get(this.$route.params.geoname);
        this.loading = false;

        let forecasts = result.long;

        forecasts.map(
          (map) => (map.date = moment(map.date).add(2, "hours").unix() * 1000)
        );

        let helper = 0;

        forecasts.forEach((fcast) => {
          this.forecasts.push(fcast);

          if (helper === 0) {
            this.forecasts3.push(fcast);
          } else if (helper === 2) {
            return (helper = 0);
          }

          helper++;
        });
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    },
    cardinals,

    getArrow(str) {
      switch (str) {
        case "N":
          return 0;
        case "NNE":
          return 22.5;
        case "NE":
          return 45;
        case "ENE":
          return 67.5;
        case "E":
          return 90;
        case "ESE":
          return 112.5;
        case "SE":
          return 135;
        case "SSE":
          return 157.5;
        case "S":
          return 180;
        case "SSO":
          return 202.5;
        case "SO":
          return 225;
        case "OSO":
          return 247.5;
        case "O":
          return 270;
        case "ONO":
          return 292.5;
        case "NO":
          return 315;
        case "NNO":
          return 337.5;

        default:
          return "-";
      }
    },

    syncExtremes: function (e) {
      var thisChart = this.chart;
      if (e.trigger !== "syncExtremes") {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function (chart) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: "syncExtremes",
              });
            }
          }
        });
      }
    },

    formatIcon(index) {
      if (this.forecasts[index].is_night) {
        return iconUrl(this.forecasts[index].ts, true);
      } else {
        return iconUrl(this.forecasts[index].ts);
      }
    },
  },

  setup() {
    const titleStack = ref(["Admin", "Prévisions"]);

    return {
      titleStack,
    };
  },

  mounted() {
    this.getForecasts();
  },
};
</script>

<style>
.highcharts-label.highcharts-data-label.highcharts-data-label-color-undefined.highcharts-tracker {
  top: 0 !important;
}
</style>